import { createTransactionRegistry } from 'entities/transaction';
import { accountPageTransactionsModel } from '../../model';

const TransactionRegistry = createTransactionRegistry(
	accountPageTransactionsModel.transactionRegistryModel,
);

export const AccountPageTransactions = () => <TransactionRegistry />;
